<template>
  <div class="payment-box white-box">
    <div class="row">
      <div class="col-12 col-md-2 d-print-none">
        <div class="info-box__icon">
          <iconBank v-if="type === 'bank_transfer'" class="icon" />
          <iconPaymentLink v-if="type === 'pay_by_link'" class="icon" />
        </div>
      </div>
      <div class="col-12 col-md-10">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import iconBank from '@/assets/icons/bank-icon.svg'
import iconPaymentLink from '@/assets/icons/payment-link-icon.svg'

export default {
  name: "PaymentBox",

  components: {
    iconBank,
    iconPaymentLink
  },

  props: {
    type: {
      type: String,
      required: true,      
    }
  },
};
</script>
  
<style lang="scss" scoped>
.payment-box {
  border-radius: 4px;
  border-color: $primary-green;
  box-shadow: 0 2px 23px 0 #ededed;
  margin-top: 20px;
  overflow: hidden;
  padding: 20px;
  position: relative;

  @include media-breakpoint-up(md) {
    padding: 35px;
  }
}

.info-box__icon {
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon {
  width: 60px;
  height: auto;
  margin: 0 0 20px 0;

  @include media-breakpoint-up(md) {
    margin: 5px 0 0 0;
  }
}
</style>
